import { getFileExtensionFromName } from './getFileExtensionFromName';
import { getFileTypeFromExtension } from './getFileTypeFromExtension';
export function getFileTypeFromFileName(fileName) {
    var extension = getFileExtensionFromName(fileName);
    return getFileTypeFromExtension(extension);
}
//# sourceMappingURL=getFileTypeFromFileName.js.map